import React from 'react';
import { WebsiteDesignProps } from './types';
import { Sun, Heart, Smile, CloudSun } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MontessoriNature: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Little Acorns";

    return (
        <div className="bg-[#fdf6e3] text-[#5d4037] min-h-screen font-sans">
             <nav className="p-6 flex justify-between items-center bg-[#fff8e1] border-b-4 border-[#8d6e63]">
                 <div className="flex items-center gap-2">
                     <Sun className="text-orange-400 fill-orange-400" size={32} />
                     <span className="text-2xl font-bold tracking-tight text-[#5d4037] font-serif">{schoolName}</span>
                 </div>
                 <Button className="bg-[#81c784] hover:bg-[#66bb6a] text-white rounded-full px-6 font-bold shadow-[0_4px_0_#388e3c] active:shadow-none active:translate-y-[4px] transition-all">
                     Parents Login
                 </Button>
             </nav>

             <main className="container mx-auto px-6 py-12">
                 <div className="bg-white rounded-[3rem] p-8 md:p-16 shadow-[8px_8px_0_#d7ccc8] border-4 border-[#efebe9] text-center mb-12">
                     <div className="inline-block bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full font-bold mb-6 text-sm">
                         🌱 Growing Happy Minds
                     </div>
                     <h1 className="text-5xl md:text-7xl font-bold text-[#5d4037] mb-6 font-serif leading-tight">
                         Play. Discover. <br/> <span className="text-[#81c784] underline decoration-wavy decoration-orange-300">Bloom.</span>
                     </h1>
                     <p className="text-xl text-[#795548] max-w-2xl mx-auto mb-10">
                         A gentle, child-led environment where learning is as natural as breathing. We nurture curiosity and kindness.
                     </p>
                     
                     <div className="flex flex-wrap justify-center gap-6">
                         <div className="w-64 h-48 bg-blue-100 rounded-2xl overflow-hidden border-4 border-white shadow-lg rotate-[-3deg] hover:rotate-0 transition-transform">
                             <img src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?q=80&w=1972&auto=format&fit=crop" className="w-full h-full object-cover" alt="Playing" />
                         </div>
                         <div className="w-64 h-48 bg-pink-100 rounded-2xl overflow-hidden border-4 border-white shadow-lg rotate-[2deg] hover:rotate-0 transition-transform">
                             <img src="https://images.unsplash.com/photo-1596464716127-f9a8759fa000?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover" alt="Learning" />
                         </div>
                     </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                     <div className="bg-[#e1bee7] rounded-3xl p-8 text-[#4a148c] shadow-[6px_6px_0_#ab47bc] border-2 border-white">
                         <Heart size={40} className="mb-4 fill-white text-white" />
                         <h3 className="text-2xl font-bold mb-3 font-serif">Kindness First</h3>
                         <p className="font-medium opacity-80">Emotional intelligence is just as important as ABCs.</p>
                     </div>
                     <div className="bg-[#b3e5fc] rounded-3xl p-8 text-[#01579b] shadow-[6px_6px_0_#039be5] border-2 border-white">
                         <CloudSun size={40} className="mb-4 fill-white text-white" />
                         <h3 className="text-2xl font-bold mb-3 font-serif">Outdoor Play</h3>
                         <p className="font-medium opacity-80">Rain or shine, we explore the wonders of nature.</p>
                     </div>
                     <div className="bg-[#fff9c4] rounded-3xl p-8 text-[#f57f17] shadow-[6px_6px_0_#fbc02d] border-2 border-white">
                         <Smile size={40} className="mb-4 fill-white text-white" />
                         <h3 className="text-2xl font-bold mb-3 font-serif">Joyful Learning</h3>
                         <p className="font-medium opacity-80">Education should be a delightful adventure.</p>
                     </div>
                 </div>
             </main>
        </div>
    );
};

export default MontessoriNature;
